import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const PhoneRingingOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M12.23 21.93c-2.3 0-4.67-1.39-7.05-4.14-2.41-2.77-3.46-5.33-3.11-7.62.29-1.94 1.49-3 1.99-3.37l.43-.38c.45-.39.92-.55 1.4-.48.8.12 1.37.86 1.78 1.49l.38.6c.36.56 1.44 2.26-.04 3.55l-.53.46c-.06.05-.14.11-.23.17-.24.16-.35.25-.38.43-.03.22.05.91 1.4 2.46 1.35 1.55 2.02 1.73 2.25 1.73.17 0 .28-.1.47-.31.07-.08.14-.15.2-.2l.52-.46c1.49-1.29 3.02.03 3.52.46l.53.46c.57.49 1.23 1.15 1.23 1.97 0 .49-.22.93-.67 1.32l-.47.41c-.39.41-1.6 1.44-3.57 1.46h-.06l.01-.01ZM5.67 7.25c-.1 0-.23.09-.32.17l-.47.41c-.41.3-1.29 1.08-1.51 2.54-.29 1.89.66 4.09 2.8 6.56 2.14 2.47 4.2 3.67 6.11 3.69a3.83 3.83 0 0 0 2.68-1.1l.51-.45c.1-.09.22-.21.22-.32 0-.1-.08-.38-.77-.98l-.53-.46c-1.08-.93-1.49-.74-1.8-.46l-.52.46s-.05.05-.08.09c-.22.24-.69.73-1.47.75-.92 0-1.94-.7-3.23-2.18-1.29-1.48-1.83-2.59-1.71-3.5.1-.78.67-1.16.95-1.35.04-.03.07-.05.1-.07l.52-.45c.32-.28.56-.65-.21-1.85l-.38-.6c-.48-.74-.74-.88-.86-.89h-.02l-.01-.01Z" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.54 3.1a.8.8 0 0 0 0 1.6 8.66 8.66 0 0 1 8.66 8.66.8.8 0 0 0 1.6 0c0-5.672-4.599-10.26-10.26-10.26Zm0 3.35a.8.8 0 0 0 0 1.6 5.316 5.316 0 0 1 5.31 5.31.8.8 0 0 0 1.6 0 6.916 6.916 0 0 0-6.91-6.91Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default PhoneRingingOutlined
